import { HelmetDexteel } from "@dexteel/mesf-core";
import { TrendDisplay } from "./components/TrendDisplay";

export const TrendDisplayPage = () => {
	return (
		<>
			<HelmetDexteel title="Trend Display" />
			<TrendDisplay />
		</>
	);
};
